import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import DYCFaqs from '../DYCFaqs';
import styles from './styles.module.scss';

function DYCFaqsModal({ isFaqsOpen, onToggleFaqs }) {
    return (
        <Modal
            isOpen={isFaqsOpen}
            toggle={onToggleFaqs}
            className={styles.faqsModal}>
            <ModalHeader toggle={onToggleFaqs}><strong>Frequently Asked Questions</strong>
            </ModalHeader>
            <ModalBody>
                <DYCFaqs />
            </ModalBody>
        </Modal>
    );
}

export default DYCFaqsModal;